import { createAction, props } from '@ngrx/store';

export const saveLocations = createAction(
    '[AUTH] save locations',
    props<{ value: any }>(),
);
